module.exports = __webpack_public_path__ + "static/media/icon-frete.b3931208.svg";